import React from "react";
import { withSnackbar } from "notistack";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Breadcrumb from "../common/breadcum";
import Form from "../common/form";
//import ProjectsTableResolucion from "./projectsTableResolucion";
import { Link } from "react-router-dom";
import { Typography, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ThemeContainer from "../common/ThemeProvider";
import MUIDataTable from "mui-datatables";

class Informe2Main extends Form {
  constructor(props) {
    super(props);

    this.state = {
      info: [],
      projectSlug: this.props.match.params.slug,
      urlI: this.props.location.state.informe1.slice(0, 18),
      i: [
        this.props.location.state.informe1,
        this.props.location.state.informe2,
        this.props.location.state.informe3,
        this.props.location.state.informe4,
        this.props.location.state.informe5,
        this.props.location.state.informe6,
        this.props.location.state.informe7,
        this.props.location.state.informe8,
        this.props.location.state.informe9,
        this.props.location.state.informe10,
      ],
    };

    const resol = () => {
      if (this.state.i[0] != null) {
        this.state.info[0] = [this.state.i[0].slice(-44)];
      }

      if (this.props.location.state.informe2 != null) {
        this.state.info[1] = [this.state.i[1].slice(-44)];
      }

      if (this.props.location.state.informe3 != null) {
        this.state.info[2] = [this.state.i[2].slice(-44)];
      }

      if (this.props.location.state.informe4 != null) {
        this.state.info[3] = [this.state.i[3].slice(-44)];
      }

      if (this.props.location.state.informe5 != null) {
        this.state.info[4] = [this.state.i[4].slice(-44)];
      }

      if (this.props.location.state.informe6 != null) {
        this.state.info[5] = [this.state.i[5].slice(-44)];
      }

      if (this.props.location.state.informe7 != null) {
        this.state.info[6] = [this.state.i[6].slice(-44)];
      }

      if (this.props.location.state.informe8 != null) {
        this.state.info[7] = [this.state.i[7].slice(-44)];
      }

      if (this.props.location.state.informe9 != null) {
        this.state.info[8] = [this.state.i[8].slice(-44)];
      }

      if (this.props.location.state.informe10 != null) {
        this.state.info[9] = [this.state.i[9].slice(-44)];
      }
      return this.state.info;
    };
    resol();
  }

  render() {
    const columns = [
      {
        name: "Informes Semestrales",
        label: "Informes Semestrales",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Link
                style={{ textDecoration: "none" }}
                onClick={(event) => {
                  event.preventDefault();
                  window.open(
                    "https://cimogsys.espoch.edu.ec/api-sgi/public/storage/projects/" +
                      value
                  );
                }}
              >
                {value}
              </Link>
            );
          },
        },
      },
      {
        name: "",
        label: "Acciones",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <React.Fragment>
                <Tooltip title="Editar" style={{ cursor: " ointer" }}>
                  <Link
                    style={{ textDecoration: "none" }}
                    to={{
                      pathname:
                        `/proyectos/` +
                        this.state.projectSlug +
                        `/informe2/dropzone`,
                      state: {
                        informe: tableMeta.rowData[0],
                        i: this.props.location.state,
                        urlI: this.state.urlI,
                      },
                    }}
                  >
                    <EditIcon color={"primary"} />
                  </Link>
                </Tooltip>
              </React.Fragment>
            );
          },
        },
      },
    ];

    const options = {
      searchPlaceholder: "Buscar",
      filterType: "dropdown",
      responsive: "scroll",
      selectableRows: "none",
    };

    const listBreadcrumbs = [
      {
        path: `/proyecto/` + this.props.match.params.slug + `/`,
        label: this.props.match.params.slug.toUpperCase(),
      },
    ];

    return (
      <Container maxWidth="md" id="projectMain">
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={`Informes Semestrales`}
        />

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <ThemeContainer>
              <MUIDataTable
                title={
                  <Typography variant="h6">
                    Lista de Informes Semestrales (Agosto - Diciembre)
                  </Typography>
                }
                data={this.state.info}
                columns={columns}
                options={options}
                responsive={"scrollFullHeight"}
              />
            </ThemeContainer>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(Informe2Main);
